import { baseApi } from '@app/store/index.api';

import {
  IOrderCustomerProfileResponse,
  IOrderDepositResponse,
  IOrderDepositUploadQuery,
  IOrderDepositUploadResponse,
  IOrderSlipResponse,
} from '../model/types';

const orderDepositApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    orderDeposit: builder.query<IOrderDepositResponse, string>({
      query: query => {
        return {
          url: `/orders/deposits?${query}`,
        };
      },
    }),
    orderCustomerProfiler: builder.query<IOrderCustomerProfileResponse, string>({
      query: orderId => {
        return {
          url: `/orders/deposits/${orderId}/customer-profile`,
          method: 'GET',
        };
      },
    }),
    orderShowPaymentSlip: builder.query<IOrderSlipResponse, string>({
      query: orderId => {
        return {
          url: `/orders/deposits/${orderId}/show-payment-slip`,
          method: 'GET',
        };
      },
    }),
    orderDepositDownload: builder.mutation<IOrderDepositUploadResponse, IOrderDepositUploadQuery>({
      query: query => {
        return {
          url: '/orders/deposits/upload',
          method: 'POST',
          body: query,
          responseHandler: async response => {
            return await response.json();
          },
        };
      },
    }),
  }),
});

export const {
  useOrderDepositQuery,
  useOrderDepositDownloadMutation,
  useLazyOrderCustomerProfilerQuery,
  useOrderShowPaymentSlipQuery,
  useLazyOrderShowPaymentSlipQuery,
} = orderDepositApi;
